// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialMedia_container__PzxF8","link":"SocialMedia_link__vpV8c","icon":"SocialMedia_icon__bGh__"};